import _ from "lodash"
import strings from "./strings.json"
import utils from "modules/utils"

const lang = "en"

export const t = key => {
  if (utils.isDev()) {
    // Show an error in development
    return _.get(strings[lang], key) || `t.${key}`
  } else {
    // Fallback to english in production
    return _.get(strings[lang], key) || _.get(strings.en, key)
  }
}

export default t
